import Fuse from 'fuse.js'

export function select(array, string) {
  var options = {
    shouldSort: true,
    threshold: 1,
    location: 0,
    distance: 200,
    maxPatternLength: 32,
    minMatchCharLength: 2,
    keys: [
      "name",
      "description",
      "tags"
    ]
  };
  var fuse = new Fuse(array, options); // "list" is the item array
  // console.log('FUSE', fuse)
  var result = fuse.search(string);
  // console.log('FUSE RESULT:', result)
  return result
}



// WEBPACK FOOTER //
// ./src/helpers/fuseHelper.js